export default {
  route:{
    'title':'信息发布系统',
    'home': '首页',
    'terminal': '终端',
    'program': '节目',
    'h5program': '节目',
    'my': '我的',
    'remote_control': '遥控',
    'task_details': '任务详情',
    'add_task': '添加任务',
    'program_list': '节目列表',
    'terminal_info': '终端信息',
    'add_resolution': '增加分辨率',
    'add_program': '增加节目',
    'material_management': '素材管理',
    'create_program': '创建节目',
    'login': '登录',
    'reset_password': '重置密码',
    'change_password': '修改密码',
    'preview': '预览'
  },
  append_field:{
    'input_code': '请输入验证码',
    'code_error': '验证码错误',
    'fill_code': '请填写验证码',
    "dOut": "3D旋转出",
    "dIn": "3D旋转进",
    "dxiao": "3D画框效果",
    "selectImage": "请选择图片",
    "onlySelectOneImage": "只能选择一张图片",
    "imageFormatError": "图片格式错误",
    "cancel": "取消",
    "selectedNumber": "已选择",
    "confirm": "确定",
    "loadinga": "加载中...",
    "loadingb": "加载中",
    "uploading": "上传中",
    "selectStartDates": "选择开始日期",
    "selectEndDates": "选择结束日期",
    "createTask": "新建任务",
    "selectPrograms": "选择节目",
    "createPrograms": "新建节目",
    "editTask": "修改任务",
    "fillTaskName": "请填写名称",
    "selectTaskGroup": "请选择任务分组",
    "selectProgram": "请选择节目",
    "selected": "已选",
    "programs": "个节目",
    "selectDevice": "请选择设备",
    "sendTaskSuccess": "任务发送成功",
    "taskName": "名称",
    "playMode": "播放模式",
    "replaceMode": "替换模式",
    "appendMode": "追加模式",
    'apotpatterns': '插播模式',
    "dateRange": "播放日期",
    "timeRange": "播放时间",
    "taskPeriod": "指定星期",
    "mon": "一",
    "tue": "二",
    "wed": "三",
    "thu": "四",
    "fri": "五",
    "sat": "六",
    "sun": "日",
    "back": "返回",
    "programList": "节目列表",
    "deviceList": "设备列表",
    "enterContent": "请输入内容",
    "taskGroup": "任务分组",
    "selectStartDate": "请选择开始日期",
    "selectEndDate": "请选择结束日期",
    "selectStartTime": "请选择开始时间",
    "selectEndTime": "请选择结束时间",
    "addTask": "添加任务",
    "topLeft": "左上角",
    "topCenter": "顶部居中",
    "topRight": "右上角",
    "leftCenter": "左对齐居中",
    "center": "居中",
    "rightCenter": "右对齐居中",
    "bottomLeft": "左下角",
    "bottomCenter": "底部居中",
    "bottomRight": "右下角",
    "enterText": "请输入文字",
    "fontColor": "字体颜色",
    "bgColor": "背景颜色",
    "scrollDirection": "滚动方向",
    "scrollSpeed": "滚动速度",
    "fontSize": "字体大小",
    "alignment": "对齐方式",
    "subtitle": "字幕",
    "enterURL": "请输入网址",
    "webPage": "网页",
    "enterMediaURL": "请输入流媒体地址",
    "media": "流媒体",
    "selectVideo": "请选择视频",
    "unsupportedFormat": "不支持的文件格式，详细支持格式请于 我的-系统帮助 中查看",
    "cancelAllSelections": "请先取消所有勾选的素材再上传新的文件",
    "fileName": "文件名",
    "fileSize": "文件大小",
    "uploadProgress": "上传进度",
    "cancelUpload": "取消上传",
    "cancelAllUploads": "取消上传",
    "leftToRights": "自左向右",
    "rightToLefts": "自右向左",
    "bottomToTops": "自下向上",
    "static": "静止",
    "slow": "慢速",
    "medium": "中速",
    "fast": "快速",
    "colorValue": "颜色值",
    "defaultEffect": "默认效果",
    "rightToLeft": "右到左",
    "leftToRight": "左到右",
    "topToBottom": "上到下",
    "bottomToTop": "下到上",
    "accordionSqueeze": "手风琴挤压",
    "zoomInFade": "放大渐变",
    "zoomOutFade": "缩小渐变",
    "depthOfField": "景深渐变",
    "leftRightRotate": "左右旋转",
    "upDownRotate": "上下旋转",
    "counterclockwiseRotate": "逆时针旋转",
    "clockwiseRotate": "顺时针旋转",
    "upDownZoom": "上下缩放",
    "scaleFade": "缩放渐变",
    "zoomInDisappearing": "放大消隐动画",
    "transparentFade": "透明渐变",
    "gradientScale": "渐变缩放",
    "deleteMaterial": "删除素材",
    "confirmDeleteMaterial": "确认删除该素材？",
    "unreviewed": "未审核",
    "normal2": "正常",
    "violating": "违规",
    "suspectedViolating": "疑似违规",
    "delete": "删除",
    "selectMaterial": "请选择素材",
    "deleteProgramGroup": "删除节目分组",
    "confirmDeleteGroup": "确认删除该分组吗？",
    'add': '添加',
    'toggle_effect': '切换效果',
    'toggle_time': '切换时间',
    'pub_toggle_time': '统一切换时间',
    'fullscreen': '全屏',
    'normal': '普通',
    'interactive': '互动',
    'main_screen': '主屏',
    'sub_screen': '副屏',
    'dual_screen': '双屏异显',
    'sync_task': '同步任务',
    'normal_mode': '普通模式',
    'basic_info': '基本信息',
    'program_info': '节目信息',
    'task_name': '节目名称',
    'task_type': '任务类型',
    'pub_task': '普通任务',
    'hu_task': '互动任务',
    'no_data': '暂无数据',
    'no_msg': '暂无信息',
    'program_name': '节目名称',
    'program_resolution': '节目分辨率',
    'program_type': '节目类型',
    'screen_category': '屏幕类别',
    'edit_program': '编辑节目',
    'edit': '编辑',
    'send': '发送',
    'create': '新建分组',
    'reload': '刷新',
    'name': '名称',
    'create_task_z': '新建任务分组',
    'ps_push_name': '请输入组名',
    'device_list': '设备列表',
    'delete_task_group': '删除任务分组',
    'confirm_delete_group': '确认删除该分组吗？',
    'delete_success': '删除成功',
    'name_cannot_be_empty': '名称不能为空',
    'character_length_limit': '字符长度必须在10位以内',
    'create_task_success': '新建任务成功',
    'create_task_failed': '新建失败',
    'confirm_delete_task': '是否确定删除任务？',
    'task_details': '任务详情',
    "download_success": "下载成功",
    "waiting_download": "等待下载",
    "downloading": "下载中",
    "confirm_delete": "是否确定删除？",
    "confirm_delete_all": "是否确定删除所有？",
    "confirm_delete_selected": "是否确定删除选中？",
    "no_data_to_clear": "没有可清除的数据！",
    "refresh": "刷新",
    "clear_all": "清除所有",
    "clear_completed": "清除已完成",
    "device_id": "设备ID",
    "task_size": "任务大小",
    "speed": "速度",
    "download_progress": "下载进度",
    "title": "标题",
    "volume": "音量",
    "deleteP": "删除节目",
    "con_P": "确认删除该节目？",
    "clear": "清空",
    "download_status": "下载状态",
    "height_width_cannot_be_empty": "高度/宽度不能为空",
    "add_success": "添加成功",
    "enter_number_between_300_to_8000": "请输入300~8000之间数",
    "width": "宽度",
    "enter_width": "请输入宽度",
    "height": "高度",
    "enter_height": "请输入高度",
    "confirm_leave_page": "确定离开此页面？",
    "add_content_to_control": "请给控件添加内容",
    "add_control": "请添加控件",
    "save_success": "保存成功",
    "save": "保存",
    "create_program": "创建节目",
    "guess": "你猜",
    "modify": "修改",
    "text": "文字",
    "image": "图片",
    "background_image": "背景图片",
    "background_music": "背景音乐",
    "replace": "替换",
    "use_this_template": "使用此模板",
    "apply_template": "应用模板",
    "enter_program_name": "请输入节目名称",
    "program_group": "节目分组",
    "select_program_group": "请选择节目分组",
    "group_list": "分组列表",
    "preview": "预览",
    "my_apps": "我的应用",
    "template_center": "模板中心",
    "home": "首页",
    "source_of_visit": "访问来源",
    "online": "在线",
    "terminal_status": "状态",
    "memory_status": "内存状态",
    "login": "登录",
    "sms_verification": "短信验证",
    "email_verification": "邮箱验证",
    "log_in": "登录",
    "enter_username": "请输入账号",
    "username_cannot_be_empty": "用户名不能为空",
    "password_cannot_be_empty": "密码不能为空",
    "incorrect_phone_format_for_verification_code": "您获取的验证码的手机号格式有误，请联系管理员修改！",
    "incorrect_email_format_for_verification_code": "您获取的验证码的邮箱格式有误，请联系管理员修改！",
    "incorrect_phone_or_email_format_for_verification_code": "您获取的验证码的邮箱或者手机格式有误，请联系管理员修改！",
    "reset_password": "重置密码",
    "remember_password": "记住密码",
    "register": "注册账号",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "关于网络安全的通知",
    "got_it": "知道了",
    "please_authenticate_for_account_safety": "为了您的账号安全，请进行身份验证",
    "enter_account": "请输入账号",
    "enter_password": "请输入密码",
    "verification_code": "验证码",
    "none": "无",
    "personal_center": "个人中心",
    "remote_control": "远程遥控",
    "refresh_success": "刷新成功！",
    "logout": "退出登陆",
    "confirm_logout": "是否确定退出登录？",
    "user_status": "用户状态",
    "customer_address": "客户地址",
    "account_period": "账户期限",
    "device_control": "设备遥控",
    "clear_cache": "清空缓存",
    "exit": "退出",
    "terminal": "终端",
    "program": "节目",
    "material": "素材",
    "my": "我的",
    "display_type": "显示类型",
    "proportion": "比例",
    "resolution": "分辨率",
    "screen_orientation": "屏幕方向",
    "landscape": "横屏",
    "portrait": "竖屏",
    "add_resolution": "新增分辨率",
    "execute_formatting_when_focus_lost": "在失焦时执行格式化",
    "select_resolution": "请选择分辨率",
    "resolution_list": "分辨率列表",
    "confirm_delete_program": "确定要删除节目吗?",
    "confirm_delete_this_program": "是否确定删除该节目？",
    "bound_tasks_exists_confirm_delete": "已绑定任务，确定要删除吗?",
    "prompt": "提示",
    "delete_failed": "删除失败",
    "modification_time": "修改时间",
    "resolution_": "分辨率",
    "associated_tasks": "已关联任务",
    "bound_task": "已绑任务",
    "program_management": "节目管理",
    "task": "任务",
    "progress": "进度",
    "phone_number": "手机号",
    "enter_phone_number": "请输入手机号",
    "password": "密码",
    "confirm_password": "确认密码",
    "enter_password_again": "请再次输入密码",
    "company_name": "公司名",
    "enter_company_name": "请输入贵司信息",
    "address": "地址",
    "enter_address": "请输入联系地址",
    "username_not_exist": "用户名不存在",
    "enter_new_password": "请输入新密码",
    "enter_new_password_again": "请再次输入新密码",
    "terminal_management": "终端管理",
    "delete_group": "删除分组",
    "pel_select_group": "请选择分组",
    "enter_device_name": "请输入设备名称",
    "delete_device": "删除设备",
    "confirm_delete_device": "确认删除该设备？",
    "terminal_information": "终端信息",
    "qr_code_error": "二维码错误",
    "device_not_supported": "设备不支持",
    "device_offline": "所选设备需在线才能下发指令，请重新选择！",
    "more": "更多",
    "device_access": "设备接入",
    "filter": "筛选",
    "all": "全部",
    "offline": "离线",
    "device_name": "设备名称",
    "device_number": "设备编号",
    "device_group": "设备分组",
    "call_device_please_wait": "调用设备，请稍等...",
    "create_terminal_group": "新建设备分组",
    "enter_search_keyword": "请输入搜索关键词",
    "bind_device": "绑定设备",
    "select_device_group": "请选择设备分组",
    "authorized": "已授权",
    "unauthorized": "未授权",
    "adjust_volume": "调节音量",
    "reboot_device": "重启设备",
    "wake_up": "唤醒",
    "sleep": "休眠",
    "shutdown": "关机",
    "clean_up_timing_on_off": "清理定时",
    "clean_up_disk": "清理磁盘",
    "clean_up_task": "清理任务",
    "send_command": "发送指令",
    "confirm2": "是否发送-",
    "terminal_operation": "终端操作",
    "bind_task": "任务信息",
    "remote_command": "远程指令",
    "remote_monitor": "远程监控",
    "adding_one_will_override_the_previous": "仅允许添加一条定时记录",
    "screenshot_in_progress_please_wait": "截取中请稍后",
    "schedule_on_off": "定时开关机",
    "shutdown_time": "关机时间",
    "startup_time": "开机时间",
    "volume_setting": "音量设置",
    "edit_device_name": "编辑设备名称",
    "please_select_time": "请选择时间",
    "device_not_online_please_retry": "设备不在线请重试",
    "sent_successfully": "下发成功",
    "version":'V4.1.8',
    'texta':'文本',
    'userName':'账号',
    "email":'邮箱',
    device_memory: '设备内存',
    device: '设备',
    device_mac: '设备MAC',
    screen_count: '屏幕数量',
    device_location: '设备定位',
    is_authorized: '是否授权',
    remark: '备注',
    device_ip: '设备IP',
    system_version: '系统版本',
    playback_date: '播放日期',
    playback_period: '播放时段',
    retrieve_again: '后重新获取',
    please_enter_password: '请输入8位数以上的包含数字、字母、特殊字符[@#$%^&+=]的密码!',
    passwords_do_not_match: '两次输入的密码不一致',
    enter_new_password2: '输入新密码',
    current_password_too_simple: '当前密码过于简单，为保护您的账户安全，请尽快修改密码，输入8位数以上包含数字、字母、特殊字符[@#$%^&+=]的字符',
    creation_time: '创建时间',
    login2: '登录',
    welcome:'欢迎登录',
    'expired_login': '身份验证已过期，请重新登录。',
    'control': '遥控',
    'add_task': '添加任务',
    'program_list': '节目列表',
    'terminal_info': '终端信息',
    'add_program': '增加节目',
    'material_management': '素材管理',
    'change_password': '修改密码',
    'enter_text_content': '请输入文本内容',
    'hit_the_wall_on_back': '在后退就是墙了',
    'last_ceremony': '仪式最后一个',
    'already_top_level': '已经是最顶层',
    'already_last_one': '已经是最后一次',
    'white_fox': '白狐',
    control_img:"图片",
    control_video:"视频",
    control_streaming:"流媒体",
    control_webPage:'网站',
    control_subtitle:"文字",
    control_HDMI:"HDMI",
    control_addbackground:"背景",
    Up:'上传',
    onlyOne:'控件只能添加一个',
    clearBg:'清除背景',
    //12.18
    get_code:"请先输入验证码",
    del_Null_Program:"是否清空列表中的内容为空节目？",
    please_select_date:"至少选择一个日期",
    last_size:"剩余空间",
    'shutdown_tips':'关机后不能远程开机',
    'last_size_upload':'请重新选择。',
    end_date_earlier_than_start_date:"结束日期不能早于开始日期",
    account_type:'用户类型',
    user_type:"普通用户",
    role_type:"角色",
    super_administrator: '超级管理员',
    term_info_empty: '终端信息为空',
    select_terminal_prompt: '请点击右上角列表按钮选择终端',
    select:"选择",
    data_empty: '数据为空！',
    content_review: '内容审核',
    start_date: '开始日期',
    end_date: '结束日期',
    start_time: '开始时间',
    end_time: '结束时间',
    select_all: '全选',
    select_group: '选择分组',
    review: '审核',
    material_type: '素材类型',
    audio: '音频',
    document: '文档',
    material_status: '素材状态',
    material_review: '素材审核',
    current_selection_requires_review: '当前选择素材,是否需要通过审核？',
    invCode:'邀请码',
    tip_invitation_empty: "请输入邀请码",
    enter_userName:'请输入用户账号',
    enter_email:'请输入邮箱',
    file_less_38:"文件小于1kb",
    viewError:'该文件不支持预览',
    user:'个人信息',
    phone_number_too_short:'手机号长度需要大于9位',
    oneImage:'背景图已存在，如需重新上传，请先删除',
    del_title: '确认删除',
    del_message: '确定删除控件吗？',
    close:'关闭',
    exit_group_name:'编辑分组名称',
    group_management:'分组管理',
    language:"语言切换",
    mixture:'混播',
    date:"日期",
    weeks:'星期',
    time:'时间',
    new_password:'新密码',
    enter_invCode:'温馨提示：邀请码请找上级管理员索取',
    msg_password: '温馨提示：请输入8位数以上的包含数字、字母、特殊字符[@#$%^&+=]的密码!',
    oneDoc:'文档已存在，如需重新上传，请先删除',
    Sunday:'星期日',
    Monday:'星期一',
    Tuesday:'星期二',
    Wednesday:'星期三',
    Thursday:'星期四',
    Friday:'星期五',
    Saturday:'星期六',
    input_error:"表单所有字段不能为空",
    video_tutorial:'资料',
    view:'在线观看',
    selectDeviceOne:'该指令，仅能选择一个设备查询',
    select_device_list:'所选设备列表',
    small_size:'小',
    medium_size:'中',
    large_size:'大',
    device_info:'设备详情',
    notification:'通知',
    notif_title:'通知内容',
    notif_msg:'自2024年11月5日起，ETV服务中心将删除存放超过1年的素材。请您知悉并提前备份重要素材，感谢您的理解与配合。',
    reduce:'缩小',
    bound_material: '已绑定素材',
    tip_material: '绑定节目的素材不能删除，请先将素材解绑',
    boundpo:'已绑定节目',
    bind_progron:'该素材已绑定节目，不能删除',
    index:'序号',
    source:'来源',
    getUploadSet_tip:' 获取素材上传禁用失败',
    getUploadstartTime_tip:'当前时间禁止上传素材，请在非禁止时间上传',
    getUploadendTim:'素材上传禁用',
    download:'下载',
    "network_import": "网络下发",
    "mobile_mode": "手机模式",
    "standalone_mode": "单机模式",
    "network_connection": "一、网络连接",
    "network_methods": "有以下两种网络连接方式：",
    "network_method_1": "（1）设置→网络和互联网→WLAN→连接网络→网络连接后打开ETV→网络图标变成白色，网络连接成功。",
    "network_method_2": "（2）打开ETV→点击鼠标右键→软件设置→选择网络下发，点击下一步→属性设置→WiFi设置→跳转到WiFi连接界面，连接网络→返回上一界面→退出回到ETV主界面→网络图标变成白色，网络连接成功。",
    "account_registration": "二、账号注册",
    "registration_methods": "有以下两种注册方法：",
    "registration_method_1": "（1）联系上级分配账号：上级用户登录账号→客户管理→添加客户→填写客户信息点击确定→新建成功，客户列表显示该账号信息。",
    "registration_method_2": "（2）自由注册账号：后台服务器登录界面→注册账号→按要求填写信息点击提交→注册成功。",
    "invitation_code_source": "邀请码来源：上级账户登录账号→系统配置→邀请码管理→新增邀请码。",
    "device_connection": "三、设备连接",
    "device_connection_steps": "打开ETV→点击鼠标右键→软件设置→选择网络下发，点击下一步→填写服务器地址（登录的后台服务器地址）、控制端口（默认8899）、用户名（上级分配或自主注册的账号用户名）→点击连接→连接成功后，设备端显示已连接，后台设备列表显示该设备信息。",
    "connect_terminal": "一、连接终端设备",
    'mobile_mode_tip':'（保持手机和设备在同一局域网下）',
    "scan_qr_wifi":'1. 手机连接设备热点，或者连接设备同一WIFI或同一局域网环境下的WIFI。',
    "scan_qr_code": "2. 左上角扫一扫：扫描终端二维码，进行连接设备。",
    "device_List": "3. 右上角设备列表：列表显示该局域网下的所有设备，勾选设备。",
    "remote_Command": "二、远程指令",
    "send_Command": "下发指令到终端设备，设备端进行相应响应",
    "quick_send_program": "三、快捷下发节目",
    "quick_send_steps": "下发快捷展示指令→获取本地图片、视频、文档素材，选择下发素材，点击确定→设置节目播放时间，点击确认→节目下发成功。",
    "program_creation": "四、节目制作",
    "new_program": "1. 新建节目：编辑至少两个字节的节目名称（会依据新建时间自动生成节目名称），根据终端设备显示屏选择屏幕方向、显示类型，新建成功后跳转到节目编辑界面。",
    "program_editing": "2. 节目编辑：选择节目播放模式（替换、插播、追加），点击“<img src='/static/images/help/icon.png' alt='' />”添加控件（图片、视频、混播、文档等），可自由调节控件大小和位置，点击“<img src='/static/images/help/icon_2.png' alt='' />”添加素材，下方可设置控件的各种属性。",
    "program_sending": "五、节目发送",
    "send_program_steps": "制作好节目→点击发送→弹出设备列表，勾选设备→点击确定→跳转到下载进度界面，显示下载进度→下载100%之后显示完成→设备端播放所下发的节目。",
    "simple_mode_title": "一、简易模式（默认）",
    "simple_mode_description": "此模式为单机默认导入方式，只需把图、视素材放在U盘的根目录下再使用U盘插入主板即可导入成功；",
    "simple_mode_note": "（PS：只支持图、视导入，相当于一个混播插件，如需其它场景则需采用单机第二种方式即可）",
    "regular_mode_title": "二、常规模式",
    "regular_mode_description": "勾选“单机模式”，点击下一步，即可出现单机模式界面（如下图)",
    "regular_mode_steps": "1. 主屏布局即可进入主屏布局页面设置<br>2.点击副屏布局即可进入副屏布局设置",
    "step_one": "第一步：",
    "step_one_description": "插上U盘，在U盘根目录新建一个文件夹，命名为“etv-media”，在etv-media目录下新建“main”文件夹，如果需要发布双屏任务，在etv-media目录下新建“double”文件夹",
    "step_two": "第二步：",
    "step_two_description": "根据选择的主屏或副屏布局，在main或double中新建1/2/3/4和布局相对应的文件夹即可",
    "step_three": "第三步：",
    "step_three_description": "将对应的布局的图片/视频文件拷贝到对应main/double文件夹下的1/2/3/4文件夹中",
    "step_four": "第四步：",
    "step_four_description": "支持全屏PDF文档播放，仅允许放一个",
    "step_five": "第五步：",
    "step_five_description": "音频请放置MAIN/DOUBLE.目录下即可，系统自动循环切换",
    "play_order_title": "播放顺序：",
    "play_order_description": "1：优先播放以数字命名的文件，数字按照从小到大的播放顺序来播<br>2：其次播放以字母命名的文件，字母按照从A到Z的播放顺序来播<br>3：最后播放以汉字命名的文件，汉字以第一个文字的首字母从A到Z的播放顺序来播",
    "document_playback_note": "关于文档播放（此开关默认打开）：3128主板和M11主板显示文档开关默认关闭（节约性能开销），需要手动开启显示文档开关",
    program_review: '节目审核',
    pass: '通过',
    not_passed_or_not_reviewed: '未通过或未审核',
    play_mode: '播放模式',
    review_status: '审核状态',
    reject: '拒绝',
    review_content: '审核内容',
    enter_review_content: '请输入审核内容',
    device_quantity: '设备数量',
    system_help:"系统帮助",
    updateInfo: '更新信息',
    'Formatspecification': '格式说明',
    'fileFormat': '文件格式',
    'imgFormat': '图片格式',
    'audioFormat': '音频格式',
    'videoFormat': '视频格式',
    'updated': '更新日期',
    'details': '1：新增我的-系统帮助菜单<br>2：新增上传素材类型，腾讯云上传，同步pc端设置<br>3：优化素材显示功能',
    "nameLengthLimit": "名称长度请限制在50字符以内",
    "customer_title": "账号查询",
    "authorized_devices": "授权设备台数",
    "enable": "启用",
    "disable": "停用",
    "expired": "账号过期",
    "valid_date": "有效日期",
    "valid_date_placeholder": "请填写有效日期",
    "capacity_rule": "服务器容量只能是100的整数倍数",
    "capacity_label": "服务器容量(M)",
    "download_speed": "下载限速",
    "submit_btn": "提交",
    "sub_accounts":"仅支持修改下级账号",
    plan_mode: '计划模式',
    default_mode: '默认模式',
    noMore: '没有更多了',
    "help": "使用帮助",
    "apk_download": "APK下载",
    "android": "安卓",
    "ios": "苹果",
    "app_name": "ETV-H5信息发布助手",
    "info_publish": "信息发布",
    "upload_material": "上传素材",
    'img_size': "图片像素异常，请检查后上传。",
    "file_size_exceed_skip":'文件大小不能超过',
    "processing":'处理中',
    'failed': '失败',
    "aliyun_storage_support": "阿里云存储支持更多格式",
  }
}